import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Dropzone from 'react-dropzone';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { uploadFiles } from '../redux/modules/common/action';

const styles = {
  card: {
    maxWidth: 400,
    marginTop: 10
  }
};

class UploadField extends React.Component {
  render() {
    const { dispatch, input, meta: { touched, error }, classes, ...custom } = this.props;
    const files = input.value;

    return (
      <Card className={classes.card}>
        <Dropzone
          className='dropzone'
          name={input.name}
          onDrop={(filesToUpload, e) => {
            filesToUpload.forEach(f => {
              const reader = new FileReader();
              reader.readAsDataURL(f);
              reader.onload = function () {
                dispatch(uploadFiles(reader.result, f.name, custom.folderName));
              }
            });
            
            input.onChange(filesToUpload);
            }
          }
        >
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Try dropping some files here, or click to select files to upload.
            </Typography>
          </CardContent>

        </Dropzone>
        {touched &&
          error &&
          <span className="error">{error}</span>}
        {files && Array.isArray(files) && (
          <ul>
            {files.map((file, i) => <li key={i}>{file.name}</li>)}
          </ul>
        )}
      </Card>
    );
  }
}

export default connect()(withStyles(styles)(UploadField));